// Mirror of the backend DEFAULT_CONTENT. Used as initial values until the
// API responds and as a fallback if the API request fails.
export const LANDING_DEFAULTS = {
  hero: {
    eyebrow: "✝ James 1:27",
    headlinePre: "A Ministry of ",
    headlineAccent: "Compassion",
    headlinePost: " for Widows",
    subCopy:
      "Providing practical help — homes, cars, and hands-on DIY needs — to widows in our community, in the spirit of James 1:27.",
    primaryCta: { label: "Support This Ministry", target: "donate" },
    secondaryCta: { label: "Learn more about us", target: "about" },
    backgroundImage: "",
  },
  mission: {
    eyebrow: "James 1:27",
    heading: "Our Christ-Centered Mission",
    body: "As a Christian charity, we serve the most vulnerable widows. We embody the love of Christ through practical service — from car maintenance to home repair — sharing the love of Jesus in every act of grace.",
  },
  stories: { eyebrow: "Testimonies", heading: "Stories of God's Provision" },
  donate: {
    heading: "Partner With Us in This Ministry",
    body: "Your gift helps provide practical repairs, care, and the hope of Christ.",
  },
  contact: {
    heading: "Get in Touch",
    body: "",
    helpCategories: [
      {
        id: "home-repair",
        label: "Home Repair",
        items: [
          "Leaking taps or pipes",
          "Boiler not working",
          "Lights, fuses, electrical",
          "Locks, hinges, doors",
          "Damp or roof issues",
          "Accessibility (rails, ramps)",
        ],
      },
      {
        id: "car-repair",
        label: "Car Repair",
        items: [
          "Flat tyres",
          "Battery / won't start",
          "Oil & fluid checks",
          "Windscreen / wipers",
          "Brakes & lights check",
          "Minor bodywork",
        ],
      },
      {
        id: "general-help",
        label: "General Help",
        items: [
          "Shopping or errands",
          "Companionship visits",
          "Form-filling / admin",
          "Medical appointments",
          "Garden tidying",
          "Not sure — just ask",
        ],
      },
    ],
  },
  footer: {
    brand: "✝ Compassion for Widows",
    copyright: "© Compassion for Widows. All rights reserved.",
    scripture: "James 1:27",
  },
};
